import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaUserGraduate, FaCheckCircle, FaFileAlt, FaShieldAlt } from 'react-icons/fa';
import '../../../../assets/css/general/footer/FeaturesDetail.css';

const StudentSupportRequests = () => {
  return (
    <div className="feature-detail-page">
      <div className="feature-detail-container">
        {/* Back Button */}
        <Link to="/" className="back-button">
          <FaArrowLeft /> Back to Home
        </Link>

        {/* Header */}
        <div className="feature-header">
          <div className="feature-icon-large">
            <FaUserGraduate />
          </div>
          <h1 className="feature-title">Student Support Requests</h1>
          <p className="feature-subtitle">
            Empowering students to request financial aid for their educational needs
          </p>
        </div>

        {/* Main Content */}
        <div className="feature-content">
          <section className="feature-section">
            <h2>Overview</h2>
            <p>
              Our Student Support Request system enables underprivileged students to 
              submit detailed requests for educational financial assistance. This feature 
              connects students directly with generous donors who want to make a real 
              difference in their lives.
            </p>
          </section>

          <section className="feature-section">
            <h2>How It Works</h2>
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">1</div>
                <h3>Create Profile</h3>
                <p>Students register and create a detailed profile with their educational background and financial needs.</p>
              </div>
              <div className="step-card">
                <div className="step-number">2</div>
                <h3>Submit Request</h3>
                <p>Submit a support request with required documents, budget breakdown, and educational goals.</p>
              </div>
              <div className="step-card">
                <div className="step-number">3</div>
                <h3>Verification</h3>
                <p>Our admin team and NGO partners verify all submitted information for authenticity.</p>
              </div>
              <div className="step-card">
                <div className="step-number">4</div>
                <h3>Get Support</h3>
                <p>Once verified, your request becomes visible to donors who can choose to support you.</p>
              </div>
            </div>
          </section>

          <section className="feature-section">
            <h2>Key Features</h2>
            <div className="features-list">
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Easy Application Process</h4>
                  <p>Simple, step-by-step form to submit your support request</p>
                </div>
              </div>
              <div className="feature-item">
                <FaFileAlt className="feature-check" />
                <div>
                  <h4>Document Upload</h4>
                  <p>Securely upload academic records, ID proofs, and financial documents</p>
                </div>
              </div>
              <div className="feature-item">
                <FaShieldAlt className="feature-check" />
                <div>
                  <h4>Privacy Protection</h4>
                  <p>Your personal information is kept secure and only shared with verified donors</p>
                </div>
              </div>
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Real-time Tracking</h4>
                  <p>Track the status of your request and donation progress in real-time</p>
                </div>
              </div>
            </div>
          </section>

          <section className="feature-section cta-section">
            <h2>Ready to Get Started?</h2>
            <p>Submit your support request today and take the first step towards achieving your educational dreams.</p>
            <button className="cta-button">Submit a Request</button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default StudentSupportRequests;